import React from "react";
import { IMaskInput } from "react-imask";

interface MaskedProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  name?: string;
  [key: string]: unknown;
}

// NIP mask: XXX XXX XX XX (10 digits with spaces)
export const NIPMaskedInput = React.forwardRef<HTMLInputElement, MaskedProps>(
  function NIPMaskedInput({ onChange, name, ...other }, ref) {
    return (
      <IMaskInput
        {...other}
        mask="000 00 00 000"
        name={name}
        inputRef={ref as React.Ref<HTMLInputElement>}
        onAccept={(value: unknown) => {
          onChange?.({
            target: { name: name ?? "", value: value as string },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
      />
    );
  }
);

// Bank account mask: XX XXXX XXXX XXXX XXXX XXXX XXXX (26-digit NRB)
export const AccountNumberMaskedInput = React.forwardRef<
  HTMLInputElement,
  MaskedProps
>(function AccountNumberMaskedInput({ onChange, name, ...other }, ref) {
  return (
    <IMaskInput
      {...other}
      mask="00 0000 0000 0000 0000 0000 0000"
      name={name}
      inputRef={ref as React.Ref<HTMLInputElement>}
      onAccept={(value: unknown) => {
        onChange?.({
          target: { name: name ?? "", value: value as string },
        } as React.ChangeEvent<HTMLInputElement>);
      }}
    />
  );
});
